import React from 'react'
import { ReactElement } from 'react'
import { AppModules, NavLinks, NavLinksArray } from './Definitions'
import { useBreadcrumb } from '@bitechsystems/btappshell'
import { Image, ImageProps } from '@mantine/core'

export const getLinkIcon = (id: string): ReactElement | undefined => {
  const obj = AppModules?.filter((val) => val.id == id)
  const first = obj?.[0]
  return first?.icon
}

export const getLinkPath = (id: string, def?: string): string => {
  const obj = AppModules?.filter((val) => val.id == id)
  const first = obj?.[0] ?? {}
  //@ts-ignore
  return first?.href ?? first?.navigate ?? def ?? '/'
}

export const getLinkProp = (id: string, prop: string, def?: any): any => {
  const obj = AppModules?.filter((val) => val.id == id)
  const first = obj?.[0] ?? {}
  return first?.[prop] ?? def
}

export const useBreadcrumbByID = (
  id: string,
  onBackCallback?: (
    e?: Event | undefined,
    comp?: HTMLElement | undefined
  ) => void
) =>
  useBreadcrumb(
    id,
    getLinkProp(id, 'title', 'Entitled'),
    getLinkPath(id),
    getLinkIcon(id),
    undefined,
    undefined,
    onBackCallback
  )

function mapTreeJSON(link: any): Object {
  return {
    label: link.title,
    children: link.children,
    id: link.id,
    icon: link.icon,
    href: link.href,
    navigate: link.navigate,
    selected:
      link.href == window.location.href ||
      link.href == window.location.pathname ||
      link.navigate == window.location.pathname,
  }
}

function loopChildren(link: NavLinks, links: NavLinksArray) {
  const childItems = links
    .filter((c) => c.parent == link.id)
    .map((lnk) => {
      return loopChildren(lnk, links)
    })

  return mapTreeJSON({
    ...link,
    children: childItems,
  })
}

export const getTreeJSON = () => {
  const links = AppModules?.filter((val) => (val.parent ?? '') == '').map(
    (val) => {
      const childItems = loopChildren(val, AppModules)?.children
      return mapTreeJSON({
        ...val,
        children: childItems,
      })
    }
  )
  return links
}

interface ImageIconProps extends ImageProps {
  size?: number
}

export const ImageIcon = (props: ImageIconProps) => {
  return (
    <Image
      radius='sm'
      src={props.src}
      alt={props.alt ?? 'Icon'}
      width={props.size ?? props.width ?? 16}
      height={props.size ?? props.height ?? 16}
      fit='cover'
    />
  )
}
